import _asyncToGenerator from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import TabelHeaderForNewOrder from './components/TabelHeaderForNewOrder.vue';
import TabelHeaderForEdit from './components/TabelHeaderForEdit.vue';
import EditTable from './components/EditTable.vue';
import TabelToolBar from './components/TabelToolBar';
import { LoadData } from '@/api/MaintainDeliveryNote2';
import util from '@/libs/util';
export default {
  components: {
    TabelHeaderForNewOrder: TabelHeaderForNewOrder,
    TabelHeaderForEdit: TabelHeaderForEdit,
    EditTable: EditTable,
    TabelToolBar: TabelToolBar
  },
  data: function data() {
    return {
      isShowTabelHeaderForNewOrder: false,
      isShowTabelHeaderForEdit: false,
      ID: null,
      VENDOR_CODE: null
    };
  },
  methods: {
    // 点击新增明细
    onHandelAddRow: function onHandelAddRow() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var vali;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(_this.$MaintainDeliveryNote2State === 'addOrder')) {
                  _context.next = 7;
                  break;
                }

                _context.next = 3;
                return _this.$refs.TabelHeaderForNewOrder.valiVENDOR_CODE();

              case 3:
                vali = _context.sent;

                // console.log('vali',vali);
                if (vali) {
                  _this.$refs.EditTable.openAddOrderRowDialog(vali);
                }

                _context.next = 8;
                break;

              case 7:
                _this.$refs.EditTable.openAddOrderRowDialog(_this.VENDOR_CODE);

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    // 点击取消
    onHandleCancel: function onHandleCancel() {
      var _this2 = this;

      if (this.$MaintainDeliveryNote2State === 'editOrder') {
        this.$confirm('返回不会保存已修改的明细, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(function () {
          _this2.$setOrderStatu('orderShow');

          _this2.$nextTick(function () {
            _this2.$refs.TabelHeaderForEdit.asyncData(_this2.ID);

            _this2.$refs.TabelToolBar.asyncStatus(_this2.ID);

            _this2.$refs.EditTable.getOrderInfo(_this2.ID);
          });
        }).catch(function () {
          _this2.$message.warning('已取消');
        });
      }
    },
    // cb新建单据成功
    cbCreateOrderSuccess: function cbCreateOrderSuccess(ID) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var params, res, row;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.ID = ID;
                console.log('cb新建单据成功, ID', ID);
                params = {
                  Page: 1,
                  // 当前页
                  Limit: 10,
                  // 分页大小
                  Data: {
                    ORGANIZE_ID: util.cookies.get('ORG_ID'),
                    ID: ID
                  }
                };
                _context2.next = 5;
                return LoadData(params);

              case 5:
                res = _context2.sent;

                if (!(res.code === 0)) {
                  _context2.next = 16;
                  break;
                }

                if (!(res.data.Items.length > 0)) {
                  _context2.next = 12;
                  break;
                }

                row = res.data.Items[0];
                _this3.VENDOR_CODE = row.VENDOR_CODE;
                _context2.next = 14;
                break;

              case 12:
                _this3.$message.warning('获取单据信息失败');

                return _context2.abrupt("return");

              case 14:
                _context2.next = 18;
                break;

              case 16:
                _this3.$message.warning('res.message');

                return _context2.abrupt("return");

              case 18:
                _this3.$setOrderStatu('orderShow');

                _this3.$nextTick(function () {
                  _this3.$refs.TabelHeaderForEdit.asyncData(ID);

                  _this3.$refs.TabelToolBar.asyncStatus(ID);

                  _this3.$refs.EditTable.getOrderInfo(ID);
                });

              case 20:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    // 上一张
    getBackOrder: function getBackOrder() {
      this.$refs.TabelHeaderForEdit.getBackUpdata();
    },
    // cb切换单据
    cbNextOrder: function cbNextOrder(ID, STATUS) {
      this.$refs.EditTable.getOrderInfo(ID);
      this.$refs.TabelToolBar.setStatus(STATUS);
    },
    // 表单校验通过
    validateHeaderSuccess: function validateHeaderSuccess(formData) {
      this.$refs.EditTable.saveForNewOrder(formData);
    },
    // 新增单据保存
    onSaveAddOrder: function onSaveAddOrder() {
      this.$refs.TabelHeaderForNewOrder.validateHeader();
    },
    // 明细导出
    onHandleExportDetailData: function onHandleExportDetailData() {
      this.$refs.TabelHeaderForEdit.ExportDetailData();
    },
    // 保存调用成功
    onSuccessSave: function onSuccessSave(id) {
      // console.log('id',id);
      this.$refs.TabelHeaderForEdit.updataStatus(id);
    },
    // 点击修改
    onClickEditOrder: function onClickEditOrder() {
      this.$refs.EditTable.onClickEditOrder();
    },
    onBeforeShowAddRowDialogForaddOrder: function onBeforeShowAddRowDialogForaddOrder() {
      this.$refs.TabelHeaderForNewOrder.onBeforeShowAddRowDialogForaddOrder();
    },
    // 表头通过保存校验
    onBeforeSaveEditOrder: function onBeforeSaveEditOrder(tableHeaderInfo) {
      this.$refs.EditTable.submitSave(tableHeaderInfo);
    },
    // 点击保存
    onSaveEditOrder: function onSaveEditOrder() {
      this.$refs.TabelHeaderForEdit.handleSave();
    },
    setHeaderForDELIVERY_NO: function setHeaderForDELIVERY_NO(row) {
      var _this4 = this;

      this.ID = row.ID;
      this.VENDOR_CODE = row.VENDOR_CODE;
      this.$refs.TabelToolBar.setHeaderForDELIVERY_NO(row);
      this.$refs.EditTable.setData(row);
      this.$nextTick(function () {
        _this4.$refs.TabelHeaderForEdit.setData(row);
      });
    },
    // 更新表单
    onUpdataOrderStaus: function onUpdataOrderStaus() {
      this.$refs.TabelHeaderForEdit.updataStatus();
    },
    // 更新按钮组
    upDateTableBar: function upDateTableBar(status) {
      console.log('更新按钮', status);
      this.$refs.TabelToolBar.controlBtnShow(status);
    },
    // 下一张
    nextOrder: function nextOrder() {
      this.$refs.TabelHeaderForEdit.nextOrderUpdata();
    },
    // 监听点击作废
    onCancelBillOrder: function onCancelBillOrder() {
      this.$refs.EditTable.CancelBillOrder(this.ID);
    },
    // 监听点击反审核
    onUnCheckBillOrder: function onUnCheckBillOrder() {
      this.$refs.EditTable.UnCheckBillOrder(this.ID);
    },
    // 监听点击审核
    onHandleAuditOrder: function onHandleAuditOrder() {
      this.$refs.EditTable.handleAuditOrder(this.ID);
    },
    // 监听点击打印
    onHandlePrint: function onHandlePrint() {
      this.$refs.TabelHeaderForEdit.PrintOrder();
    },
    // 邮件发送
    onSendMail: function onSendMail() {
      this.$refs.TabelHeaderForEdit.mailSend();
    }
  },
  watch: {
    $MaintainDeliveryNote2State: {
      handler: function handler(nawValue) {
        // console.log('单据操作状态 MaintainDeliveryNote2OrderState==>',nawValue);
        if (nawValue === 'listShow') {
          // 订单列表
          this.VENDOR_CODE = null;
          this.isShowTabelHeaderForNewOrder = false;
          this.isShowTabelHeaderForEdit = false;
        } else if (nawValue === 'addOrder') {
          // 新增订单
          this.isShowTabelHeaderForNewOrder = true;
          this.isShowTabelHeaderForEdit = false;
        } else if (nawValue === 'orderShow') {
          // 订单明细
          this.isShowTabelHeaderForNewOrder = false;
          this.isShowTabelHeaderForEdit = true;
        } else if (nawValue === 'editOrder') {}
      },
      immediate: true
    }
  }
};